"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitButtonTextOptions = exports.sellValue = exports.orderTypes = exports.futuresOrderTypes = exports.futuresOrderFormTypes = exports.buyValue = exports.advancedOrderFormTypes = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var sellValue = exports.sellValue = '1';
var buyValue = exports.buyValue = '0';
var orderTypes = exports.orderTypes = {
  //t('Market')
  market: {
    orderType: '1',
    displayName: 'Market Order'
  },
  //t('Limit')
  limit: {
    orderType: '2',
    displayName: 'Limit Order'
  },
  //t('Stop Market')
  stopMarket: {
    orderType: '3',
    displayName: 'Stop Market'
  },
  //t('Stop Limit')
  stopLimit: {
    orderType: '4',
    displayName: 'Stop Limit'
  },
  //t('Trailing Stop Market')
  trailingStopMarket: {
    orderType: '5',
    displayName: 'Trailing Stop Market'
  },
  //t('Trailing Stop Limit')
  trailingStopLimit: {
    orderType: '6',
    displayName: 'Trailing Stop Limit'
  },
  //t('Report Block Trade')
  reportBlockTrade: {
    orderType: '7',
    displayName: 'Report Block Trade'
  },
  //t('Fill Or Kill')
  fillOrKill: {
    orderType: '2',
    displayName: 'Fill Or Kill'
  },
  //t('Immediate or Cancel')
  immediateOrCancel: {
    orderType: '2',
    displayName: 'Immediate or Cancel'
  },
  //t('Reserve Order')
  reserveOrder: {
    orderType: '2',
    displayName: 'Reserve Order'
  },
  //t('Spot')
  spot: {
    orderType: '2',
    displayName: 'Spot'
  },
  //t('Cross')
  cross: {
    orderType: '2',
    displayName: 'Cross'
  },
  //t('Isolated')
  isolated: {
    orderType: '2',
    displayName: 'Isolated'
  }
};
var futuresOrderTypes = exports.futuresOrderTypes = {
  //t('Market')
  market: {
    orderType: '8',
    displayName: 'Market'
  },
  //t('Limit')
  limit: {
    orderType: '8',
    displayName: 'Limit'
  },
  //t('Conditional')
  conditional: {
    orderType: '8',
    displayName: 'Conditional'
  }
};
var advancedOrderFormTypes = exports.advancedOrderFormTypes = {
  market: orderTypes.market,
  limit: orderTypes.limit,
  stopMarket: orderTypes.stopMarket,
  stopLimit: orderTypes.stopLimit,
  trailingStopMarket: orderTypes.trailingStopMarket,
  trailingStopLimit: orderTypes.trailingStopLimit,
  fillOrKill: orderTypes.fillOrKill,
  immediateOrCancel: orderTypes.immediateOrCancel,
  reserveOrder: orderTypes.reserveOrder
};
var futuresOrderFormTypes = exports.futuresOrderFormTypes = {
  market: futuresOrderTypes.market,
  limit: futuresOrderTypes.limit,
  stopMarket: futuresOrderTypes.conditional
};

/**
 * t('Place Sell Order', { ns: 'order' })
 * t('Place Buy Order', { ns: 'order' })
 */
var submitButtonTextOptions = exports.submitButtonTextOptions = _defineProperty(_defineProperty({}, sellValue, 'Place Sell Order'), buyValue, 'Place Buy Order');